import { useContext } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFacetData } from '~/context/srp/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import Label from './Label';
import useExpand from './useExpand';
import type WithClassName from './WithClassName';

export default function Features({ className }: WithClassName) {
  const [show, setShow] = useExpand(false);
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const facetData = useFacetData();
  const features = facetData.cvnaFeatures ?? {};

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-features"
      facetContent={features}
      facetName="features"
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <div className="grid gap-32 p-32">
        {Object.keys(features).map(category => {
          return (
            <div className="grid gap-16" key={category}>
              <div className="text-grey-5 tl-body-s">{category}</div>
              <div className="grid gap-16">
                {features[category].map(({ key: feature, displayName }) => (
                  <Checkbox
                    analyticsAttributes={{ category }}
                    checked={appliedFilters.cvnaFeatures?.includes(feature)}
                    facet="cvnaFeatures"
                    filter={feature}
                    id={`features-${displayName}`}
                    key={feature}
                    label={<Label displayName={displayName} />}
                    onChange={() =>
                      updateListFilter({
                        filterKey: 'cvnaFeatures',
                        value: feature
                      })
                    }
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </FilterDrawer>
  );
}
